import { Flex } from '@mantine/core';
import React from 'react';
import { FiChevronRight } from 'react-icons/fi';

interface CategoryItemProps {
  categoryId: string;
  categoryName: string;
  // subcategories: string[];
  depth2: any;
  onMouseEnter: (id: any) => void;
  onMouseLeave: () => void;
  onMouseEnterSubCategory: (id: any) => void;
  onMouseLeaveSubCategory: () => void;
  hoveredCategory: string | null;
  hoveredCategorySubCategory: string | null;
}

export type { CategoryItemProps };

const CategoryItem: React.FC<CategoryItemProps> = ({
  categoryId,
  categoryName,
  // subcategories,
  depth2,
  onMouseEnter,
  onMouseLeave,
  onMouseEnterSubCategory,
  onMouseLeaveSubCategory,
  hoveredCategory,
  hoveredCategorySubCategory
}) => {
  return (
    <div
      className="menu-category-item"
      onMouseEnter={() => onMouseEnter(categoryId)}
      onMouseLeave={() => {
        if (!hoveredCategorySubCategory) onMouseLeave();
      }}
    >
      <a
        style={{
          color: 'black',
          textDecoration: 'none'
        }}
        href={`/event?cat=${formatUrl(categoryName)}`}
      >
        <div className="menu-category-item__category">
          <h3 className="m-0">{categoryName}</h3>
          {/* i want if depth2 and depth3 length is more than 0, then make arrow */}
          {depth2.length > 0 && (
            <div className="menu-category-item__category__arrow">
              <FiChevronRight />
            </div>
          )}
        </div>
      </a>
      {depth2.length > 0 && hoveredCategory === categoryId && (
        <div className="menu-category-item__subcategory">
          <ul>
            {depth2.length > 0 &&
              depth2.map((subcategory) => (
                <div
                  style={{ position: 'relative' }}
                  key={subcategory.categoryId}
                >
                  <a
                    style={{
                      color: 'black',
                      textDecoration: 'none'
                    }}
                    href={`/event?cat=${formatUrl(subcategory.categoryName)}`}
                  >
                    <li
                      key={subcategory.categoryId}
                      onMouseEnter={() =>
                        onMouseEnterSubCategory(subcategory.categoryId)
                      }
                      onMouseLeave={() => {
                        if (!hoveredCategorySubCategory)
                          onMouseLeaveSubCategory();
                      }}
                    >
                      <Flex align={'center'} justify={'space-between'}>
                        {subcategory.categoryName}
                        {subcategory.depth3.length > 0 && (
                          <div className="menu-category-item__category__arrow">
                            <FiChevronRight />
                          </div>
                        )}
                      </Flex>
                    </li>
                  </a>

                  {subcategory.depth3.length !== 0 &&
                    hoveredCategorySubCategory === subcategory.categoryId && (
                      <div className="menu-category-item__subcategory__sub-subcategory">
                        <ul>
                          {subcategory.depth3.length > 0 &&
                            subcategory.depth3.map((subcategory3) => (
                              <a
                                style={{
                                  color: 'black',
                                  textDecoration: 'none'
                                }}
                                href={`/event?cat=${formatUrl(
                                  subcategory3.categoryName
                                )}`}
                              >
                                <li key={subcategory3.categoryId}>
                                  {subcategory3.categoryName}
                                </li>
                              </a>
                            ))}
                        </ul>
                      </div>
                    )}
                </div>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

const formatUrl = (url: string) => {
  return url.replace(/ /g, '-').toLowerCase();
};

export default CategoryItem;
